//@flow
import { call, put, takeLatest, all } from "redux-saga/effects";

import {
  UPDATE_TEAM_REQUEST,
  UPDATE_TEAM_SUCCESS,
  UPDATE_TEAM_ERROR,
  CREATE_TEAM_CONVERSATION_REQUEST,
  CREATE_TEAM_CONVERSATION_ERROR,
  CREATE_TEAM_CONVERSATION_SUCCESS,
} from "./constants";

import { fetchApi } from "../api";
import { showAlert } from "../profileSettings/actions";
import i18n from ".././../i18n";

const endPoints = {
  updateTeam: "/v1/teams/update",
  uploadImage: "/v1/upload/sign-s3?",
  conversationTeamCreation: "/v1/teams/conversationTeamCreation",
};

const updateTeamApi = (data: string) => {
  return fetchApi(endPoints.updateTeam, data, "patch");
};

const conversationTeamCreationApi = data => {
  return fetchApi(endPoints.conversationTeamCreation, data, "post");
};

function* updateTeamApiFlow(action) {
  try {
    const response = yield call(updateTeamApi, action.payload);
    yield put({ type: UPDATE_TEAM_SUCCESS, payload: response });

    yield put(showAlert({ title: i18n.t('team-updated-success') }));
    // yield put({ type: USER_CAMPAIGN_GET_TEAM_SUCCESS, payload: response });
  } catch (error) {
    console.log(error);
    yield put({ type: UPDATE_TEAM_ERROR });
  }
}

function* createTeamConversationApiFlow(action) {
  try {
    const team = yield call(conversationTeamCreationApi, action.payload);
    yield put({ type: CREATE_TEAM_CONVERSATION_SUCCESS, payload: team });
  } catch (error) {
    console.log(error);
    yield put({ type: CREATE_TEAM_CONVERSATION_ERROR });
  }
}

function* trackWatcher() {
  yield all([
    takeLatest(UPDATE_TEAM_REQUEST, updateTeamApiFlow),
    takeLatest(CREATE_TEAM_CONVERSATION_REQUEST, createTeamConversationApiFlow),
  ]);
}

export default trackWatcher;
